/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SubstanceTypeDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    name: string;
    category: SubstanceTypeDto.category;
};
export namespace SubstanceTypeDto {
    export enum category {
        ADDITIVE = 'ADDITIVE',
        BASE_OIL = 'BASE_OIL',
    }
}

